:host {
  display: block;
}

.spw-select {
  position: relative;
  &__container {
    position: relative;
  }
  &__arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 12px;
    pointer-events: none;
    color: var(--spw-color-themes-grey-grey-600);
    font-size: 12px;
  }
  &__trigger {
    width: 100%;
    height: 40px;
    border-radius: 4px;
    border: 1px solid var(--spw-color-themes-grey-grey-800);
    background-color: #fff;
    font-size: 16px;
    color: var(--spw-color-themes-grey-grey-800);
    position: relative;
    padding: 0;
    margin: 0;
    appearance: none;
    padding: 0 12px;
    padding-right: 40px;

    &:hover {
      outline: 4px solid var(--spw-color-themes-grey-grey-300);
    }

    &:focus-visible {
      outline: 3px solid var(--spw-ds-focus);
      outline-offset: 2px;
    }

    /* Add the chevron */
    &::after {
      content: '\f078'; /* Font Awesome chevron-down unicode */
      font-family: 'Font Awesome 5 Free';
      font-weight: 900;
      font-size: 14px;
      color: var(--spw-color-themes-grey-grey-800);
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      pointer-events: none; /* Ensure the chevron does not block clicks */
    }

    .spw-select--is-error & {
      border-color: var(--spw-colors-states-error-error-300);
    }

    .spw-select--large & {
      height: 60px;
      padding: 0 24px;
      font-size: 18px;
    }

    .spw-select--disabled & {
      border-color: var(--spw-color-themes-grey-grey-400);
      background: var(--spw-color-themes-grey-grey-100);
      color: var(--spw-color-themes-grey-grey-500);
      cursor: not-allowed;
      &::placeholder {
        color: var(--spw-color-themes-grey-grey-500);
      }
      &:hover,
      &:focus,
      &:focus-visible {
        outline: none;
      }
    }
  }
}
